export default "/images/d16a1501ee58e80e3462025ba86ee25c.avif";